import { render, staticRenderFns } from "./IntergralCenter.vue?vue&type=template&id=f140088e&scoped=true"
import script from "./IntergralCenter.vue?vue&type=script&lang=js"
export * from "./IntergralCenter.vue?vue&type=script&lang=js"
import style0 from "./IntergralCenter.vue?vue&type=style&index=0&id=f140088e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f140088e",
  null
  
)

export default component.exports